import { localStorageThemeIdentifier } from 'constants/settings'
import { ToastAutoClose } from 'constants/toast'
import {
  Backdrop,
  CssBaseline,
  LinearProgress,
  ThemeProvider,
  useTheme,
} from '@mui/material'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import Loading from 'components/Loading'
import darkTheme from 'config/theme/dark'
import lightTheme from 'config/theme/light'
import { useAuth } from 'context/AuthProvider'
import { Routes } from 'navigation'
import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setDarkModeAction } from 'store/slices/app.slice'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  const dispatch = useAppDispatch()
  const { isDarkMode, loadingMessage } = useAppSelector(state => state.app)
  const [isReady, setReady] = useState(false)
  const theme = useTheme()
  const { isLoading } = useAuth()

  useEffect(() => {
    const darkModeFromLS = window.localStorage.getItem(
      localStorageThemeIdentifier,
    )
    if (darkModeFromLS === null)
      window.localStorage.setItem(
        localStorageThemeIdentifier,
        JSON.stringify(false),
      )
    else dispatch(setDarkModeAction(JSON.parse(darkModeFromLS)))
    setReady(true)
  }, [dispatch])

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <ToastContainer autoClose={ToastAutoClose} />
        <CssBaseline />
        {!isReady || isLoading ? (
          <LinearProgress />
        ) : (
          <>
            <Backdrop
              open={!!loadingMessage}
              sx={{ zIndex: theme.zIndex.drawer + 1 }}
            >
              <Loading />
            </Backdrop>
            <Routes />
          </>
        )}
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default App
